import {HeadFC, PageProps} from "gatsby"
import {Fragment} from "react"
import ContactUsFullForm from "~/components/Forms/ContactUsFullForm"
import Blank from "~/components/Sections/Blank/Blank"
import HeroSection from "~/components/Sections/HeroSection/HeroSection"
import MultiStyleText from "~/components/UI/MultiStyleText/MultiStyleText"
import RichTextField from "~/components/UI/RichText/RichText"
import ScrollButton from "~/components/UI/ScrollButton/ScrollButton"
import SectionContainer from "~/components/UI/SectionContainer/SectionContainer"
import {useLinksQuery} from "~/queries/LinksQuery"
import {SEO} from "../components/UI/SEO/SEO"
import {PageContext} from "../types/PageContext"
import getTextFromHTML from "../utilities/getTextFromHTML"

type ContactsPageContext = PageContext<Queries.ContactsPageQuery["allContentfulPaginaContatti"]["edges"][0]["node"]>

interface ContactsPageProps extends PageProps<any, ContactsPageContext> {}

const ContactsPage: React.FC<ContactsPageProps> = props => {
    const contactsPageData = props.pageContext.data

    return (
        <Fragment>
            <HeroSection
                image={contactsPageData.immagine?.gatsbyImageData}
                imageAlt={contactsPageData.immagine?.title}
                mobileImage={contactsPageData.immagineMobile?.gatsbyImageData}
            >
                <MultiStyleText flex className1="hero-title-part-1-d2bh" className2="hero-title-part-2-d2bh">
                    {contactsPageData.titolo}
                </MultiStyleText>
            </HeroSection>
            <SectionContainer tabbed marginPost customTab={<ScrollButton />} withFadeInEffect>
                <Blank>
                    <h3 className="no-margin">{contactsPageData.titolo2}</h3>
                    <RichTextField style={{marginTop: "var(--gutter-5)"}} className="font-h6 chars-h6-80">
                        {contactsPageData.testo?.raw}
                    </RichTextField>
                </Blank>
            </SectionContainer>
            <SectionContainer>
                <ContactUsFullForm />
            </SectionContainer>
        </Fragment>
    )
}
export default ContactsPage

export const Head: HeadFC<any, ContactsPageContext> = props => {
    const contactsPageData = props.pageContext.data

    const links = useLinksQuery()

    return (
        <SEO
            title={contactsPageData.titolo}
            description={getTextFromHTML(contactsPageData.testo?.raw)}
            language={props.pageContext.language}
            image={contactsPageData.immagine?.url}
            imageAlt={contactsPageData.immagine?.title}
            siteUrl={`${process.env.SITE_URL}${links.contacts.url}`}
        />
    )
}
